// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_zY1","cls2":"RelatedWorksCard-cls2_Vfd RelatedWorksCard-cls1_zY1","nohover":"RelatedWorksCard-nohover_fAz","altLook":"RelatedWorksCard-altLook_JK6"};